<template>
  <div class="relative" :class="globalSearchClass">
    <input
type="text" :class="inputClass" :value="modelValue" placeholder="Search" :disabled="readonly"
      @input="onInput" @keyup.enter="handleSearchCall"
>
    <button v-if="clearable && modelValue.trim().length > 0" :class="clearClass" @click="handleClearCall">
      <font-awesome-icon icon="times" class="w-4 h-4 text-red-600" />
    </button>

    <button :class="buttonclass" @click="handleSearchCall">
      <img :src="imgSrc" alt="Search Icon" class="w-full">
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    globalSearchClass: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    buttonclass: {
      type: String,
      default: '',
    },
    clearClass: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: require('@/assets/images/searchBar-icon.png'),
    },
    readonly: {
      type: Boolean,
      default: false
    },
    onEnter: {

    },
    onClear: {

    }
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value); // for v-model
      this.$emit('input', value);             // for @input
    },

    handleSearchCall() {
      if (this.onEnter) {
        this.onEnter()
      }
    }, 

    handleClearCall() {
if (this.onClear) {
        this.onClear()
      }      
    },
  }
}
</script>
